/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PressureUnit = {
    Atmosphere: 'PressureUnit.Atmosphere',
    Bar: 'PressureUnit.Bar',
    Centibar: 'PressureUnit.Centibar',
    Decapascal: 'PressureUnit.Decapascal',
    Decibar: 'PressureUnit.Decibar',
    DynePerSquareCentimeter: 'PressureUnit.DynePerSquareCentimeter',
    FootOfElevation: 'PressureUnit.FootOfElevation',
    FootOfHead: 'PressureUnit.FootOfHead',
    Gigapascal: 'PressureUnit.Gigapascal',
    Hectopascal: 'PressureUnit.Hectopascal',
    InchOfMercury: 'PressureUnit.InchOfMercury',
    InchOfWaterColumn: 'PressureUnit.InchOfWaterColumn',
    Kilobar: 'PressureUnit.Kilobar',
    KilogramForcePerSquareCentimeter: 'PressureUnit.KilogramForcePerSquareCentimeter',
    KilogramForcePerSquareMeter: 'PressureUnit.KilogramForcePerSquareMeter',
    KilogramForcePerSquareMillimeter: 'PressureUnit.KilogramForcePerSquareMillimeter',
    KilonewtonPerSquareCentimeter: 'PressureUnit.KilonewtonPerSquareCentimeter',
    KilonewtonPerSquareMeter: 'PressureUnit.KilonewtonPerSquareMeter',
    KilonewtonPerSquareMillimeter: 'PressureUnit.KilonewtonPerSquareMillimeter',
    Kilopascal: 'PressureUnit.Kilopascal',
    KilopoundForcePerSquareFoot: 'PressureUnit.KilopoundForcePerSquareFoot',
    KilopoundForcePerSquareInch: 'PressureUnit.KilopoundForcePerSquareInch',
    KilopoundForcePerSquareMil: 'PressureUnit.KilopoundForcePerSquareMil',
    Megabar: 'PressureUnit.Megabar',
    MeganewtonPerSquareMeter: 'PressureUnit.MeganewtonPerSquareMeter',
    Megapascal: 'PressureUnit.Megapascal',
    MeterOfElevation: 'PressureUnit.MeterOfElevation',
    MeterOfHead: 'PressureUnit.MeterOfHead',
    Microbar: 'PressureUnit.Microbar',
    Micropascal: 'PressureUnit.Micropascal',
    Millibar: 'PressureUnit.Millibar',
    MillimeterOfMercury: 'PressureUnit.MillimeterOfMercury',
    MillimeterOfWaterColumn: 'PressureUnit.MillimeterOfWaterColumn',
    Millipascal: 'PressureUnit.Millipascal',
    NewtonPerSquareCentimeter: 'PressureUnit.NewtonPerSquareCentimeter',
    NewtonPerSquareMeter: 'PressureUnit.NewtonPerSquareMeter',
    NewtonPerSquareMillimeter: 'PressureUnit.NewtonPerSquareMillimeter',
    Pascal: 'PressureUnit.Pascal',
    PoundForcePerSquareFoot: 'PressureUnit.PoundForcePerSquareFoot',
    PoundForcePerSquareInch: 'PressureUnit.PoundForcePerSquareInch',
    PoundForcePerSquareMil: 'PressureUnit.PoundForcePerSquareMil',
    PoundPerInchSecondSquared: 'PressureUnit.PoundPerInchSecondSquared',
    TechnicalAtmosphere: 'PressureUnit.TechnicalAtmosphere',
    TonneForcePerSquareCentimeter: 'PressureUnit.TonneForcePerSquareCentimeter',
    TonneForcePerSquareMeter: 'PressureUnit.TonneForcePerSquareMeter',
    TonneForcePerSquareMillimeter: 'PressureUnit.TonneForcePerSquareMillimeter',
    Torr: 'PressureUnit.Torr',
    CentimeterOfWaterColumn: 'PressureUnit.CentimeterOfWaterColumn',
    MeterOfWaterColumn: 'PressureUnit.MeterOfWaterColumn'
} as const;
export type PressureUnit = typeof PressureUnit[keyof typeof PressureUnit];


export function PressureUnitFromJSON(json: any): PressureUnit {
    return PressureUnitFromJSONTyped(json, false);
}

export function PressureUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressureUnit {
    return json as PressureUnit;
}

export function PressureUnitToJSON(value?: PressureUnit | null): any {
    return value as any;
}

/**
 * Check if a given object implements the PressureUnit interface.
 */
 export function instanceOfPressureUnit(value: any): value is PressureUnit {
    return Object.values(PressureUnit).includes(value)
}

